import { useSyncExternalStore } from 'react';

/**
 * Mini Prixia (recorrido 2-nov): mientras un momento/animación de la mini está en pantalla
 * (`CapaDeMomento`), ningún tutorial ni bienvenida se abre encima. La regla vive acá: la capa
 * se anota al montarse y se borra al irse; quien abre algo por su cuenta pregunta
 * `useHayMomentoAbierto()`.
 */
let abiertos = 0;
const oyentes = new Set<() => void>();
const avisar = () => oyentes.forEach((f) => f());

/** Anota un momento abierto. Devuelve cómo borrarlo. */
export function anotarMomentoAbierto(): () => void {
  abiertos += 1;
  avisar();
  let vigente = true;
  return () => {
    if (!vigente) return;
    vigente = false;
    abiertos -= 1;
    avisar();
  };
}

export function hayMomentoAbierto(): boolean {
  return abiertos > 0;
}

export function useHayMomentoAbierto(): boolean {
  return useSyncExternalStore(
    (f) => {
      oyentes.add(f);
      return () => oyentes.delete(f);
    },
    hayMomentoAbierto,
    () => false
  );
}
